import type { AdapterRegistry } from '@/types/adapters';
import { trercAdapter } from './trercAdapter';
import { narAdapter } from './narAdapter';
import { censusAcsAdapter } from './censusAcsAdapter';
import { redfinAdapter } from './redfinAdapter';
import { zillowAdapter } from './zillowAdapter';
import { mayBackendAdapter } from './mayBackendAdapter';
import { enabledSourceIds } from '@/data/sourceRegistry';

const ALL_ADAPTERS: AdapterRegistry = {
  'realtor-com-live': mayBackendAdapter,
  trerc: trercAdapter,
  nar: narAdapter,
  'census-acs': censusAcsAdapter,
  redfin: redfinAdapter,
  zillow: zillowAdapter,
};

/** Only the adapters whose source is currently enabled (registry + feature flags). */
export function getActiveAdapters(): AdapterRegistry {
  const active: AdapterRegistry = {};
  for (const id of enabledSourceIds()) {
    const adapter = ALL_ADAPTERS[id];
    if (adapter) active[id] = adapter;
  }
  return active;
}

export { ALL_ADAPTERS };
